import { Component, OnInit } from '@angular/core';
import { AlertController, NavController, ToastController } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilService } from '../../../service/util.service';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserProfile } from '../../../models/user-profile.model';
import { environment } from '../../../../environments/environment';
import { Storage } from '@ionic/storage';
import { RoleAccess } from '../../../models/role-access.model';
import { UserData } from '../../../providers/user-data';
import * as utf8 from 'crypto-js/enc-utf8';
import AES = require('crypto-js/aes');

@Component({
  selector: 'app-customer-edit',
  templateUrl: './customer-edit.page.html',
  styleUrls: ['./customer-edit.page.scss'],
})
export class CustomerEditPage implements OnInit {

  baseUrl: any;
  formCustomerEdit: FormGroup;
  customerId: any;
  customerData: any;
  token: any;
  userProfile: UserProfile = new UserProfile();
  roleAccess = new RoleAccess();
  
  countryData:any[]=[];
  cityData:any[]=[];
  districtData:any[]=[];
  subdistrictData:any[]=[];
  provinceData:any[]=[];
  counterData:any[]=[];
  countryId:any=0;
  provinceId:any=0;
  cityId:any=0;
  districtId:any=0;
  subdistrictId:any=0;
  counterId:any=0;
  
  selectedProvince:any[]=[];
  selectedCity:any[]=[];
  selectedDistrict:any[]=[];
  selectedSubdistrict:any[]=[];
  maxDate:any=[];
  minDate:any=[];
  readonlyReceipt:boolean=false;
  disabledCounter:boolean=false;
  status:any;
  isProvinceRequired:boolean=false;

  constructor(
    private fb: FormBuilder,
    private activeRoute: ActivatedRoute,
    private utilService: UtilService,
    private alertController: AlertController,
    private navCtrl: NavController,
    private toastCtrl: ToastController,
    private http: HttpClient,
    private storage: Storage,
    private userData: UserData,
    private router: Router
  ) {
    this.baseUrl = environment.apiUrl;
  }

  ngOnInit() {
    this.buildFormCustomerEdit();

    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.roleAccess = this.userData.checkAccess(this.router.url, access, this.userProfile);
        if(!this.roleAccess || this.roleAccess.update!='1'){
          this.toastCtrl.create({ duration: 2000, message: 'You Are Not Allowed to Access this Page' }).then(t => t.present());
          this.navCtrl.navigateForward(['/']);
        }
        const today = new Date();
        const tenYearsAgo = new Date();
        const oneHundredYearsAgo = new Date();
        tenYearsAgo.setFullYear(today.getFullYear() - 10);
        oneHundredYearsAgo.setFullYear(today.getFullYear() - 100);
        this.maxDate = tenYearsAgo.toISOString().split('T')[0];
        this.minDate = oneHundredYearsAgo.toISOString().split('T')[0];
        this.getData();
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }

  buildFormCustomerEdit() {
    this.formCustomerEdit = this.fb.group({
      customerName: [],
      identityNumber: [],
      phone: [],
      birthPlace: [],
      birthDate:[],
      gender:[],
      profession:[],
      address:[],
      receiptNo:[],
      counter:[],
      email:[],
      country:[],
      province:[],
      city:[],
      district:[],
      subdistrict:[],
    });
  }

  getData() {
    this.activeRoute.queryParams.subscribe((snapshot) => {
      let myKey=environment.myKey;
      this.customerId = AES.decrypt(snapshot.i, myKey).toString(utf8);
      this.utilService.loadingPresent('Harap tunggu...')
      .then(() => {
        this.http.get(this.baseUrl + 'customer/' + this.customerId + '/edit?token=' + this.token)
        .subscribe((response: any) => {
          this.utilService.loadingDismiss();
          this.customerData = response.results.data;
          this.countryData = response.results.country;
          this.provinceData = response.results.province;
          this.cityData = response.results.city;
          this.districtData = response.results.district;
          this.subdistrictData = response.results.subdistrict;
          this.countryId = this.customerData.country_id;
          this.provinceId = this.customerData.province_id;
          this.cityId = this.customerData.city_id;
          this.districtId = this.customerData.district_id;
          this.counterData = response.results.counter;
          this.counterId = this.customerData.registration_counter;
          const country = this.countryData.find(item => item.id == this.countryId);
          const province = this.provinceData.find(item => item.id == this.provinceId);
          const city = this.cityData.find(item => item.id == this.cityId);
          const district = this.districtData.find(item => item.id == this.districtId);
          const counter = this.counterData.find(item => item.id ==this.counterId)
          this.status = this.customerData.active;
          this.filterProvinceByCountry();
          this.filterCityByProvince();
          this.filterDistrictByCity();
          this.filterSubdistrictByDistrict();
          this.subdistrictId = this.customerData.subdistrict_id;
          const subdistrict = this.subdistrictData.find(item => item.id == this.subdistrictId);
          const receiptNo = this.customerData.first_receipt_no ? this.customerData.first_receipt_no : '';
          if(this.customerData.first_receipt_no!==''){
            this.readonlyReceipt=true;
          }
          if(this.customerData.registration_counter!=0){
            this.disabledCounter=true;
          }
          this.formCustomerEdit = this.fb.group({
            customerName: [this.customerData.customer_name,  
              [
                  Validators.required,
                  Validators.pattern(/^[A-Za-z]+(?: [A-Za-z]+)*$/)
              ]
            ],
            identityNumber: [this.customerData.identity_number],
            phone: [this.customerData.phone,[Validators.required, Validators.pattern(/^(\+|08)[0-9]*$/),]],
            email: [this.customerData.email,[Validators.required,Validators.email]],
            birthPlace: [this.customerData.birth_place],
            birthDate:[this.customerData.birth_date],
            gender:[this.customerData.gender],
            profession:[this.customerData.profession],
            address:[this.customerData.address],
            country: [country],
            province: [province],
            city: [city],
            district: [district],
            subdistrict: [subdistrict],
            receiptNo:[receiptNo],
            counter:[counter]
          });
          var countryControl = this.formCustomerEdit.get('country');
          var provinceControl = this.formCustomerEdit.get('province');
          if (countryControl && provinceControl) {
            countryControl.valueChanges.subscribe(function(value) {
              if (value == 103) {
                provinceControl.setValidators([Validators.required]);
                this.isProvinceRequired = true;
              } else {
                provinceControl.clearValidators();
                this.isProvinceRequired = false;
              }
              provinceControl.updateValueAndValidity();
            });
          }
        }, () => {
          this.utilService.loadingDismiss();
          this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        });
      });
    });
  }

  numberOnlyValidation(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }
  phoneNumberValidation(event: any) {
    const input = event.target as HTMLInputElement;
    const inputChar = String.fromCharCode(event.charCode);

    // Allow angka
    if (/[0-9]/.test(inputChar)) {
      return;
    }

    // Allow "+" hanya jika:
    // - karakter adalah "+"
    // - posisi cursor di index 0
    // - belum ada "+" sebelumnya
    if (
      inputChar === '+' &&
      input.selectionStart === 0 &&
      !input.value.includes('+')
    ) {
      return;
    }

    // Selain itu ditolak
    event.preventDefault();
  }

  updateData() {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      const customerData = this.formCustomerEdit.getRawValue();

      const paramsOpts = new HttpParams()
        .set('token', this.token)

      let receiptNo = customerData.receiptNo ?  customerData.receiptNo : '';
      let birthPlace = customerData.birthPlace ?  customerData.birthPlace : '';
      let birthDate = customerData.birthDate ?  customerData.birthDate : '';
      let gender = customerData.gender ?  customerData.gender : '';
      let profession = customerData.profession ?  customerData.profession : '';
      let address = customerData.address ?  customerData.address : '';
      let customerName = customerData.customerName ?  customerData.customerName : '';
      let identityNumber = customerData.identityNumber ?  customerData.identityNumber : '';
      let email = customerData.email ?  customerData.email : '';
      const reqOpts = new HttpHeaders()
        .set('Accept', 'application/json'),
      formData = new FormData();
      formData.append('customer_name', customerName);
      formData.append('identity_number', identityNumber);
      formData.append('phone', customerData.phone);
      formData.append('email',email);
      formData.append('updated_by', this.userProfile.username);
      formData.append('_method', 'PUT');
      formData.append('birth_place', birthPlace);
      formData.append('birth_date', birthDate);
      formData.append('gender', gender);
      formData.append('profession', profession);
      formData.append('address', address);
      formData.append('country_id',this.countryId);
      formData.append('province_id',this.provinceId);
      formData.append('city_id',this.cityId);
      formData.append('district_id', this.districtId);
      formData.append('subdistrict_id', this.subdistrictId);
      formData.append('registration_counter',this.counterId);
      formData.append('customer_type_id', '1');
      formData.append('receipt_no',receiptNo);

      this.http.post(this.baseUrl + 'customer/' + this.customerId, formData, { headers: reqOpts, params: paramsOpts })
      .subscribe((response: any) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 200) {
          this.showConfirmUpdate();
        }
        else if(response.status.code === 202) {
          this.toastCtrl.create({ duration: 2000, message: response.status.description }).then(t => t.present());
        
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Terdapat Error' }).then(t => t.present());
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }

  async showConfirmUpdate() {
    const alert = await this.alertController.create({
      header: 'Notification',
      cssClass:'custom-alert-class',
      message: 'Data sudah tersimpan!',
      buttons: [
        {
          text: 'OK',
          handler: () => {
            this.navCtrl.navigateForward(['/customer']);;
          }
        }
      ]
    });
    await alert.present();
  }


  selectCountry(event){
    this.countryId = event.value.id;
    this.provinceId ='';
    this.selectedProvince =[];
    this.formCustomerEdit.get('province').reset();
    this.cityId ='';
    this.formCustomerEdit.get('city').reset();
    this.districtId ='';
    this.formCustomerEdit.get('district').reset();
    this.subdistrictId ='';
    this.formCustomerEdit.get('subdistrict').reset();
    
    var provinceControl = this.formCustomerEdit.get('province');
    if (this.countryId  == 103) {
      provinceControl.setValidators([Validators.required]);
      this.isProvinceRequired = true;
    } else {
      provinceControl.clearValidators();
      this.isProvinceRequired = false;
    }
    provinceControl.updateValueAndValidity();
    this.filterProvinceByCountry();
  }
  filterProvinceByCountry(){
    this.selectedCity=[];
    this.selectedDistrict=[];
    this.selectedSubdistrict=[];
    this.selectedProvince = this.provinceData.filter(x=>x.country_id==this.countryId);
  }
  selectProvince(event){
    this.provinceId = event.value.id;
    this.cityId ='';
    this.districtId ='';
    this.subdistrictId ='';
    this.formCustomerEdit.get('city').reset();
    this.formCustomerEdit.get('district').reset();
    this.formCustomerEdit.get('subdistrict').reset();
    this.filterCityByProvince();
  }
  filterCityByProvince(){
    this.selectedDistrict=[];
    this.selectedSubdistrict=[];
    this.selectedCity = this.cityData.filter(x=>x.province_id==this.provinceId);
  }
  selectCity(event){
    this.cityId = event.value.id;
    this.districtId ='';
    this.subdistrictId ='';
    this.formCustomerEdit.get('district').reset();
    this.formCustomerEdit.get('subdistrict').reset();
    this.filterDistrictByCity();
  }
  filterDistrictByCity(){
    this.selectedSubdistrict=[];
    this.selectedDistrict = this.districtData.filter(x=>x.city_id==this.cityId);
  }
  selectDistrict(event){
    this.districtId = event.value.id;
    this.subdistrictId ='';
    this.formCustomerEdit.get('subdistrict').reset();
    this.filterSubdistrictByDistrict();
  }
  filterSubdistrictByDistrict(){
    this.selectedSubdistrict = this.subdistrictData.filter(x=>x.district_id==this.districtId);
  }
  selectSubdistrict(event){
    this.subdistrictId = event.value.id;
  }
  selectCounter(event){
    this.counterId = event.value.id;
  }
  getAge(birthDateString: string): number {
    const today = new Date();
    const birthDate = new Date(birthDateString);

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    // Cek apakah sudah ulang tahun tahun ini atau belum
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    return age;
  }

  validationBeforeSave(){
    //cek apakah tanggal lahir valid (max 10 tahun)
    // cek apakah provinsi sesuai negara
    let isValid = true;
    let errMsg ='';
    let checkProvince = this.provinceData.find(x=>x.id==this.provinceId);
    const customerData = this.formCustomerEdit.getRawValue();
    let birthDate = customerData.birthDate ?  customerData.birthDate : '';
    if(checkProvince){
      if(checkProvince.country_id != this.countryId){
        isValid = false;
        errMsg = " Provinsi tidak sesuai dengan negara";
      }
    }
    let age = this.getAge(birthDate);
    if(age<10){
      errMsg = " Belum berusia 10 tahun";
    }
    if(!isValid){
      this.toastCtrl.create({ duration: 2000, message: errMsg }).then(t => t.present()); 
    }
    else{
      this.updateData();
    }
  }
  getCounterNameById(id: number): string {
    const found = this.counterData.find(c => c.id == id);
    return found ? found.counter_name : '';
  }
  validateCustomerName(event: any) {
    const value = event.target.value || '';
    const cleanValue = value.replace(/[^A-Za-z ]/g, '');
    event.target.value = cleanValue;
    this.formCustomerEdit
        .get('customerName')
        .setValue(cleanValue, { emitEvent: false });
  }
}